export default class State {
  static get all(): Array<{name: string, abbr: string}> {
    return [
      {name: 'Alabama', abbr: 'AL'},
      {name: 'Alaska', abbr: 'AK'},
      {name: 'Arizona', abbr: 'AZ'},
      {name: 'Arkansas', abbr: 'AR'},
      {name: 'California', abbr: 'CA'},
      {name: 'Colorado', abbr: 'CO'},
      {name: 'Connecticut', abbr: 'CT'},
      {name: 'Delaware', abbr: 'DE'},
      {name: 'District of Columbia', abbr: 'DC'},
      {name: 'Florida', abbr: 'FL'},
      {name: 'Georgia', abbr: 'GA'},
      {name: 'Hawaii', abbr: 'HI'},
      {name: 'Idaho', abbr: 'ID'},
      {name: 'Illinois', abbr: 'IL'},
      {name: 'Indiana', abbr: 'IN'},
      {name: 'Iowa', abbr: 'IA'},
      {name: 'Kansas', abbr: 'KS'},
      {name: 'Kentucky', abbr: 'KY'},
      {name: 'Louisiana', abbr: 'LA'},
      {name: 'Maine', abbr: 'ME'},
      {name: 'Maryland', abbr: 'MD'},
      {name: 'Massachusetts', abbr: 'MA'},
      {name: 'Michigan', abbr: 'MI'},
      {name: 'Minnesota', abbr: 'MN'},
      {name: 'Mississippi', abbr: 'MS'},
      {name: 'Missouri', abbr: 'MO'},
      {name: 'Montana', abbr: 'MT'},
      {name: 'Nebraska', abbr: 'NE'},
      {name: 'Nevada', abbr: 'NV'},
      {name: 'New Hampshire', abbr: 'NH'},
      {name: 'New Jersey', abbr: 'NJ'},
      {name: 'New Mexico', abbr: 'NM'},
      {name: 'New York', abbr: 'NY'},
      {name: 'North Carolina', abbr: 'NC'},
      {name: 'North Dakota', abbr: 'ND'},
      {name: 'Ohio', abbr: 'OH'},
      {name: 'Oklahoma', abbr: 'OK'},
      {name: 'Oregon', abbr: 'OR'},
      {name: 'Pennsylvania', abbr: 'PA'},
      {name: 'Rhode Island', abbr: 'RI'},
      {name: 'South Carolina', abbr: 'SC'},
      {name: 'South Dakota', abbr: 'SD'},
      {name: 'Tennessee', abbr: 'TN'},
      {name: 'Texas', abbr: 'TX'},
      {name: 'Utah', abbr: 'UT'},
      {name: 'Vermont', abbr: 'VT'},
      {name: 'Virginia', abbr: 'VA'},
      {name: 'Washington', abbr: 'WA'},
      {name: 'West Virginia', abbr: 'WV'},
      {name: 'Wisconsin', abbr: 'WI'},
      {name: 'Wyoming', abbr: 'WY'}
    ];
  }

  static get forVSelect(): Array<{label: string, value: string}> {
    return [
      {label: 'Alabama', value: 'AL'},
      {label: 'Alaska', value: 'AK'},
      {label: 'Arizona', value: 'AZ'},
      {label: 'Arkansas', value: 'AR'},
      {label: 'California', value: 'CA'},
      {label: 'Colorado', value: 'CO'},
      {label: 'Connecticut', value: 'CT'},
      {label: 'Delaware', value: 'DE'},
      {label: 'District of Columbia', value: 'DC'},
      {label: 'Florida', value: 'FL'},
      {label: 'Georgia', value: 'GA'},
      {label: 'Hawaii', value: 'HI'},
      {label: 'Idaho', value: 'ID'},
      {label: 'Illinois', value: 'IL'},
      {label: 'Indiana', value: 'IN'},
      {label: 'Iowa', value: 'IA'},
      {label: 'Kansas', value: 'KS'},
      {label: 'Kentucky', value: 'KY'},
      {label: 'Louisiana', value: 'LA'},
      {label: 'Maine', value: 'ME'},
      {label: 'Maryland', value: 'MD'},
      {label: 'Massachusetts', value: 'MA'},
      {label: 'Michigan', value: 'MI'},
      {label: 'Minnesota', value: 'MN'},
      {label: 'Mississippi', value: 'MS'},
      {label: 'Missouri', value: 'MO'},
      {label: 'Montana', value: 'MT'},
      {label: 'Nebraska', value: 'NE'},
      {label: 'Nevada', value: 'NV'},
      {label: 'New Hampshire', value: 'NH'},
      {label: 'New Jersey', value: 'NJ'},
      {label: 'New Mexico', value: 'NM'},
      {label: 'New York', value: 'NY'},
      {label: 'North Carolina', value: 'NC'},
      {label: 'North Dakota', value: 'ND'},
      {label: 'Ohio', value: 'OH'},
      {label: 'Oklahoma', value: 'OK'},
      {label: 'Oregon', value: 'OR'},
      {label: 'Pennsylvania', value: 'PA'},
      {label: 'Rhode Island', value: 'RI'},
      {label: 'South Carolina', value: 'SC'},
      {label: 'South Dakota', value: 'SD'},
      {label: 'Tennessee', value: 'TN'},
      {label: 'Texas', value: 'TX'},
      {label: 'Utah', value: 'UT'},
      {label: 'Vermont', value: 'VT'},
      {label: 'Virginia', value: 'VA'},
      {label: 'Washington', value: 'WA'},
      {label: 'West Virginia', value: 'WV'},
      {label: 'Wisconsin', value: 'WI'},
      {label: 'Wyoming', value: 'WY'}
    ];
  }

  static stateNameFromAbbreviation(abbr): string{
    for(let i = 0; i < State.all.length; i++)
    {
      if(State.all[i].abbr === abbr)
      {
        return State.all[i].name;
      }
    }
  }

  static stateAbbreviationFromName(name): string {
    if (name.length === 2) {
      return State.all.filter(el => el.abbr === name.toUpperCase())[0].abbr || "";
    } else {
      let state = State.all.filter(el => el.name.toLowerCase() === name.toLowerCase())[0];
      return state ? state.abbr : name
    }
  }
}